import { render } from "./ArenaModal.vue?vue&type=template&id=e72974e4&scoped=true&ts=true"
import script from "./ArenaModal.vue?vue&type=script&lang=ts"
export * from "./ArenaModal.vue?vue&type=script&lang=ts"

import "./ArenaModal.vue?vue&type=style&index=0&id=e72974e4&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72974e4"]])

export default __exports__